import { ErrorPage } from 'modules/app/components/pages/error-page/ErrorPage';
import { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

export const FullScreenLayout = () => (
  <ErrorBoundary
    FallbackComponent={ErrorPage}
    onError={(error: Error, info: ErrorInfo) => {
      // biome-ignore lint/suspicious/noConsole: Please use the logger. You know who you are. Disabling for now.
      console.error('Page Crash', error, info?.componentStack);
      return;
    }}
  >
    <Outlet />
  </ErrorBoundary>
);
